const gfy = () => {
  let y = new Date();
  y = y.getFullYear() + 543;
  y = y.toString();
  y = y.substring(2);
  return parseInt(y);
};

export default gfy;
